(function(module) {
    'use strict';

    function FilesCtrl($state, $http, ListModifier, envService, Store, $mdDialog, App, filesBulkDelete) {

        this.setDefault = () => {
            this.loading = true;
            this.selectedFilesCount = 0;
            this.selectedFiles = null;
        };

        this.$onDestroy = () => {

        };

        this.getData = () => {
            const subAccountId = Store.getCurrentSubAccountId();
            return this
                .getListOfFiles({ accountId: this.account.id, subAccountId })
                .then((files) => {
                    this.files = Store.setMultiModelData('files', files);
                    this.loading = false;
                    // disable this as we need to show no files for the sub accounts
                    // if (!this.files.length) {
                    //     this.goToFileUpload();
                    // }
                })
                .catch((error) => {
                    console.log({ error });
                    this.loading = false;
                });
        };

        this.onSubAccountChange = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.$onInit = () => {
            this.account = Store.getCurrentAccount();
            this.subAccountId = Store.getCurrentSubAccountId();
            this.SLS_URI = envService.read('SLS_URI');

            this.setDefault();
            this.getData();
        };

        this.goToFileUpload = () => {
            $state.go('root.files.add');
        };

        this.getListOfFiles = ({ accountId, subAccountId }) => {
            const params = {};
            if (subAccountId) {
                _.set(params, 'subAccountId', subAccountId);
            }
            const request = {
                method: 'GET',
                url: `${this.SLS_URI}/files/list/${accountId}`,
                params,
            };
            return $http(request)
                .then(({ data }) => {
                    return data;
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.findApps = () => {
            return App.find({ filter: { fields: ['id', 'data'] } }).$promise;
        };

        this.delete = (id) => {

            //file used by apps
            this.findApps()

                .then((apps) => {
                    let modalTitle;
                    let modalConfirmationText;
                    let inUseByApps = false;
                    //check if selected file is being used by any of the apps
                    apps.forEach((app) => {
                        if (app.data && app.data.files) {
                            if (app.data.files.indexOf(id) > -1) {
                                inUseByApps = true;
                                return false;
                            }
                        }
                    });
                    if (inUseByApps) {
                        modalTitle = 'This file is used by some of your apps. Are you sure you want to permanently remove this file?';
                        modalConfirmationText = 'Please note that the file will be automatically removed from all the apps that are using this file. We advise to check your apps before deleting.';
                    } else {
                        modalTitle = 'Are you sure you want to permanently remove this file?';
                        modalConfirmationText = '';
                    }

                    $mdDialog.show({
                        locals: {
                            title: modalTitle,
                            confirmationText: modalConfirmationText,
                            cancelText: 'Cancel',
                            confirmText: 'Yes, remove',

                        },
                        controller: ($scope, $mdDialog) => {
                            $scope.cancel = () => {
                                $mdDialog.hide();
                            };
                            $scope.confirm = () => {
                                $scope.cancel();
                                const request = {
                                    method: 'DELETE',
                                    url: `${this.SLS_URI}/files/delete`,
                                    data: {
                                        id,
                                        accountId: this.account.id,
                                    },
                                };

                                return $http(request)
                                    .then(() => {
                                        Store.removeSingleModelData('files', id);
                                        if (!this.files.length) {
                                            this.goToFileUpload();
                                        }
                                    })
                                    .catch((error) => {
                                        console.error(error);
                                        Raven.captureException(error);
                                    });

                            };
                        },
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });

                });
        };

        this.removeSelected = () => {
            this.filesSelectedCount();
            let countFileText;
            if (this.selectedFilesCount === 1) {
                countFileText = 'file';
            } else {
                countFileText = 'files';
            }

            this.findApps()
                .then((apps) => {

                    let modalTitle;
                    let modalConfirmationText;
                    let inUseByApps = false;

                    //check if selected files are being used by any of the apps
                    apps.forEach((app) => {
                        if (app.data && app.data.files) {

                            this.selectedFiles.forEach((selectedFile) => {
                                if (app.data.files.indexOf(selectedFile.id) > -1) {
                                    inUseByApps = true;
                                    return false;
                                }
                            });
                        }

                    });
                    if (inUseByApps) {
                        modalTitle = `Some of the selected files are used by your apps. Are you sure you want to permanently remove ${this.selectedFilesCount} ${countFileText} ?`;
                        modalConfirmationText = 'Please note that the files will be also automatically removed from all the apps that are using them. We advise to check your apps before deleting.';
                    } else {
                        modalTitle = 'Are you sure you want to permanently remove selected files?';
                        modalConfirmationText = '';
                    }

                    $mdDialog.show({
                        locals: {
                            title: modalTitle,
                            confirmationText: modalConfirmationText,
                            cancelText: 'Cancel',
                            confirmText: 'Yes, remove',

                        },
                        controller: ($scope, $mdDialog) => {
                            $scope.cancel = () => {
                                $mdDialog.hide();
                            };

                            $scope.confirm = () => {
                                const request = filesBulkDelete.buildBulkDeleteRequest(
                                    this.SLS_URI,
                                    this.account.id,
                                    this.selectedFiles,
                                );

                                return $http(request)
                                    .then(() => {
                                        this.selectedFiles.forEach((fileToRemove) => {
                                            let fileToRemoveId = fileToRemove.id;
                                            Store.removeSingleModelData('files', fileToRemoveId);
                                            this.search = '';

                                            if (!this.files.length) {
                                                this.goToFileUpload();
                                            }
                                        });
                                        this.selectedFilesCount = 0;
                                        $scope.cancel();
                                    })
                                    .catch((error) => {
                                        console.error(error);
                                        Raven.captureException(error);
                                    });
                            };
                        },
                        controllerAs: '$ctrl',
                        bindToController: true,
                        templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                        parent: angular.element('body'),
                        clickOutsideToClose: true,
                        escapeToClose: true,
                    });

                });

        };

        this.save = (file) => {
            const fileName = file.form.changeText.$modelValue;
            const request = {
                method: 'PUT',
                url: `${this.SLS_URI}/files/update`,
                data: {
                    id: file.id,
                    accountId: this.account.id,
                    fileName: encodeURI(fileName),
                },
            };

            return $http(request)
                .then(() => {
                    file.editTitle = false;
                    file.hideEditButtonFlag = false;
                    file.hideSaveButtonFlag = true;
                    file.fileName = fileName;
                    Store.setSingleModelData('files', file.id, file);
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.edit = (file) => {
            file.editTitle = true;
            file.hideEditButtonFlag = true;
            file.hideSaveButtonFlag = false;
        };

        this.goToFilePreview = (file) => {
            const fileUrl = file.original;
            const isVideo = file.contentType && file.contentType.match(/video/);
            $mdDialog.show({
                locals: {
                    fileUrl,
                },
                controller: function($scope, $mdDialog, fileUrl, $state) {
                    this.cancel = function() {
                        $mdDialog.hide();
                    };
                    this.fileUrl = fileUrl;
                    this.isVideo = isVideo;

                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/files/image-preview-modal/image-preview-modal.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
            });
        };

        this.filesSelectedCount = () => {
            this.selectedFiles = this.files.filter(file => file.checked === true);
            this.selectedFilesCount = this.selectedFiles.length;

        };

        this.isChecked = (file) => {
            file.checked = !file.checked;
            this.filesSelectedCount();

        };

        this.selectAll = () => {
            this.filteredItems.forEach((file) => {
                file.checked = true;
            });
            this.filesSelectedCount();
        };

        this.unselectAll = () => {
            this.files.forEach((file) => {
                file.checked = false;
            });
            this.filesSelectedCount();
        };

    }

    module
        .config(function($stateProvider, $translatePartialLoaderProvider, envServiceProvider) {

            const FEATURES = envServiceProvider.read('features');
            const FILES = _.get(FEATURES, 'files', false);

            $stateProvider
                .state('root.files', {
                    url: '/files',
                    data: {
                        pageTitle: 'FILES.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<files-component/>',
                        },
                    },
                    bodyClass: 'page--files',
                    resolve: {
                        show: function($state) {
                            if (FEATURES && !FILES) {
                                return $state.go('root');
                            }
                        },
                    },
                });

            $translatePartialLoaderProvider.addPart('/js/files');
        })
        .component('filesComponent', {
            templateUrl: '/js/files/files.html',
            controller: FilesCtrl,
        });

})(angular.module('rocket.components'));
